import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import ReserveTimeModal from './ReserveTimeModal';

const App = props => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <ReserveTimeModal
      isOpen={isOpen}
      calendarOptions={props.calendars.map(({partyName, scheduleId}) => ({
        label: partyName,
        value: scheduleId
      }))}
      closeModal={() => {
        setIsOpen(false);
        props.onClose();
      }}
      partyScheduleId={props.partyScheduleId}
      appointmentId={props.appointmentId}
      categoryId={props.categoryId}
      description={props.description}
      startDate={props.startDate}
      startTime={props.startTime}
      duration={props.duration}
    />
  );
}

App.propTypes = {
  calendars: PropTypes.arrayOf(PropTypes.shape({
    partyName: PropTypes.string,
    scheduleId: PropTypes.number,
  })).isRequired,
  partyScheduleId: PropTypes.number.isRequired,
  appointmentId: PropTypes.string,
  categoryId: PropTypes.number,
  description: PropTypes.string,
  startDate: PropTypes.string,
  startTime: PropTypes.string,
  duration: PropTypes.number,
  onClose: PropTypes.func.isRequired,
};

export default hot(module)(App);
